module.exports = __webpack_public_path__ + "img/delete-icon.dc82cc6d.svg";